import React, { useState, useEffect } from 'react';
import logo from '../assets/logo.png';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      // 1. Handle background color change
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }

      // 2. Handle ScrollSpy (active section)
      const sections = ['home', 'features', 'contact'];
      const scrollPosition = window.scrollY + 150; // Offset for navbar height

      sections.forEach(sectionId => {
        const element = document.getElementById(sectionId);
        if (element) {
          const offsetTop = element.offsetTop;
          const height = element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + height) {
            setActiveSection(sectionId);
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <a href="https://store.vertex-group.site" className="nav-logo" style={{ textDecoration: 'none' }}>
          <img src={logo} alt="مجموعة فيرتكس" className="logo-img" />
          <div className="logo-text">
            <span className="logo-title">VERTEX</span>
            <span className="logo-subtitle">GROUP</span>
            <span className="logo-location">ريف دمشق - داريا</span>
          </div>
        </a>
        
        <div className="nav-links">
          <a href="#home" className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}>الرئيسية</a>
          <a href="#features" className={`nav-link ${activeSection === 'features' ? 'active' : ''}`}>خدماتنا</a>
          <a href="#contact" className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`}>من نحن</a>
          <a href="https://store.vertex-group.site" className="nav-link" style={{ fontWeight: 'bold', color: 'var(--primary-color)' }}>المتجر</a>
          <a href="#contact" className="btn-secondary" style={{ padding: '0.6rem 1.25rem' }}>اتصل بنا</a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
